const IMG_SALAO =
    "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&w=1200&h=900&fit=crop&q=80";
const IMG_INTERIOR =
    "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?crop=entropy&cs=srgb&fm=jpg&w=1200&h=900&fit=crop&q=80";
const IMG_CLINICA =
    "https://images.pexels.com/photos/16571735/pexels-photo-16571735.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop";
const IMG_PROFISSIONAL =
    "https://images.unsplash.com/photo-1695527081848-1e46c06e6458?crop=entropy&cs=srgb&fm=jpg&w=1200&h=900&fit=crop&q=80";

export const SEGMENTS = {
    "salao-de-beleza": {
        slug: "salao-de-beleza",
        nome: "Salão de Beleza",
        segmento: "salões de beleza",
        title: "Contabilidade para Salão de Beleza, Contabeleza",
        description:
            "Contabilidade especializada para salões de beleza: adequação à Lei do Salão Parceiro, tributos organizados, contratos de parceria e gestão integrada ao ilove.me.",
        eyebrow: "Para salões de beleza",
        h1Lines: ["A contabilidade que", "entende a rotina", "do seu salão."],
        subtitle:
            "Da relação com os profissionais parceiros aos tributos do dia a dia: uma contabilidade que fala a língua de quem vive de beleza.",
        proposta:
            "O salão de beleza vive de agenda cheia, equipe grande e margem apertada. A Contabeleza organiza a parte contábil, fiscal e trabalhista da operação, com orientação especializada na Lei do Salão Parceiro, para você decidir com números claros e mais segurança jurídica.",
        dores: [
            "Profissionais sem contrato e insegurança na relação de trabalho",
            "Impostos calculados sobre uma receita que não reflete a operação real",
            "Comissões e cotas conferidas manualmente toda semana",
            "Financeiro e contabilidade que não conversam entre si",
        ],
        beneficios: [
            "Apoio na adequação à Lei do Salão Parceiro, com contratos e rotinas estruturados",
            "Enquadramento fiscal revisado para o modelo do seu salão",
            "Orientação sobre notas discriminadas entre cota-salão e cota-parceiro",
            "Rotina organizada com a plataforma ilove.me e acompanhamento contábil",
        ],
        servicos: [
            "Adequação à Lei do Salão Parceiro",
            "Gestão tributária especializada",
            "Rotinas de equipe e contratações",
            "Apoio na implantação do ilove.me",
        ],
        imagem: {
            src: IMG_SALAO,
            alt: "Interior de salão de beleza com espelhos redondos e cadeiras de atendimento",
            width: 1200,
            height: 900,
        },
        depoimentos: [
            {
                quote: "Nem acredito que passamos anos pagando imposto que não precisava.",
                name: "Luciana e Conrado",
                business: "Beauty Studio, Rio de Janeiro",
            },
            {
                quote: "Vou passar a dormir tranquila sem medo de ações trabalhistas.",
                name: "Rosi",
                business: "Salão de Beleza, Taboão da Serra",
            },
        ],
        faq: [
            {
                pergunta: "O que é a Lei do Salão Parceiro?",
                resposta:
                    "É a Lei nº 13.352/2016, que criou o regime de parceria entre salões de beleza e profissionais como cabeleireiros, manicures e esteticistas. Em vez de vínculo empregatício, as partes firmam um contrato de parceria e a remuneração é dividida em cotas previamente acordadas.",
            },
            {
                pergunta: "Quem pode aderir à Lei do Salão Parceiro?",
                resposta:
                    "Estabelecimentos que exercem atividades como cabeleireiro, barbearia, estética, manicure e pedicure, depilação e maquiagem, entre outras previstas na lei. A adesão exige contrato formal e práticas de gestão coerentes com o modelo, cada operação precisa ser analisada individualmente.",
            },
            {
                pergunta: "A Lei do Salão Parceiro reduz automaticamente os impostos?",
                resposta:
                    "Não. A lei permite que a cota-parte do profissional parceiro não componha a receita do salão, o que pode reduzir a base de cálculo dos tributos. O resultado depende do enquadramento fiscal, das alíquotas aplicáveis e da correta operação do modelo, por isso a análise contábil é indispensável.",
            },
            {
                pergunta: "Qual é a diferença entre profissional parceiro e empregado?",
                resposta:
                    "O empregado tem vínculo de CLT, com salário, jornada e subordinação. O parceiro atua por contrato de parceria, recebe cotas sobre os serviços e mantém autonomia. Se a rotina real tiver características de emprego, há risco de reconhecimento de vínculo, o contrato precisa refletir a prática.",
            },
            {
                pergunta: "Um salão pode trabalhar com profissionais MEI?",
                resposta:
                    "Pode, desde que a relação seja de fato entre empresas: o MEI presta serviço com autonomia, sem subordinação nem jornada imposta. Quando a realidade é de emprego, o CNPJ do profissional não elimina o risco trabalhista. A estrutura correta depende da análise do caso.",
            },
        ],
        ctaTexto:
            "Conte como o seu salão funciona hoje. Um especialista Contabeleza analisa o seu cenário e aponta o caminho de adequação.",
    },
    barbearia: {
        slug: "barbearia",
        nome: "Barbearia",
        segmento: "barbearias",
        title: "Contabilidade para Barbearia, Contabeleza",
        description:
            "Contabilidade especializada para barbearias: Lei do Salão Parceiro, comissões organizadas, tributos sob medida e gestão integrada ao ilove.me.",
        eyebrow: "Para barbearias",
        h1Lines: ["Sua barbearia com", "a casa em ordem", "e o caixa claro."],
        subtitle:
            "Comissões, parceiros, tributos e agenda: a contabilidade que acompanha o ritmo da sua barbearia sem travar o seu crescimento.",
        proposta:
            "Barbearia cresce rápido: cadeiras novas, barbeiros parceiros, produtos na prateleira. A Contabeleza organiza contratos, comissões, tributos e financeiro para a operação crescer com previsibilidade, e sem sustos no fim do mês.",
        dores: [
            "Fechamento de comissões feito na mão aos sábados",
            "Dúvida entre contratar como CLT ou como parceiro",
            "Faturamento misturado entre serviços e venda de produtos",
            "Falta de previsibilidade sobre impostos e pró-labore",
        ],
        beneficios: [
            "Orientação na estruturação de contratos de parceria pela Lei nº 13.352/2016",
            "Rotina de comissões e cotas organizada com apoio do ilove.me",
            "Escrituração separando serviços e produtos, como exige o Fisco",
            "Relatórios simples para acompanhar caixa e margem",
        ],
        servicos: [
            "Adequação à Lei do Salão Parceiro",
            "BPO financeiro",
            "Gestão tributária especializada",
            "Apoio na implantação do ilove.me",
        ],
        imagem: {
            src: IMG_INTERIOR,
            alt: "Interior de barbearia com iluminação técnica e estações de atendimento",
            width: 1200,
            height: 900,
        },
        depoimentos: [
            {
                quote: "Se não fosse a Contabeleza não tinha resistido à pandemia.",
                name: "Will",
                business: "Salão de Beleza e Barbearia, São Paulo",
            },
        ],
        faq: [
            {
                pergunta: "Como funciona a contabilidade para barbearias?",
                resposta:
                    "A contabilidade organiza o enquadramento fiscal da barbearia, a emissão de notas, a folha ou os contratos de parceria dos barbeiros e a separação entre receita de serviços e venda de produtos. Com a rotina organizada, o fechamento do mês deixa de ser um mistério.",
            },
            {
                pergunta: "Barbearia pode aderir à Lei do Salão Parceiro?",
                resposta:
                    "Sim. A atividade de barbearia está entre as previstas na Lei nº 13.352/2016. A adesão exige contrato de parceria formalizado, divisão de cotas documentada e práticas de gestão compatíveis com o modelo, a análise do seu caso define a viabilidade.",
            },
            {
                pergunta: "Barbeiro parceiro é a mesma coisa que funcionário?",
                resposta:
                    "Não. O funcionário tem vínculo de CLT, com jornada e subordinação. O barbeiro parceiro trabalha com autonomia e recebe cotas pelos serviços, conforme o contrato de parceria. Se o dia a dia tiver características de emprego, o contrato sozinho não basta, a prática precisa acompanhar o modelo.",
            },
            {
                pergunta: "Vale a pena o barbeiro ser MEI?",
                resposta:
                    "Depende do faturamento e da forma de trabalho. O MEI pode ser uma porta de entrada para a formalização, mas não resolve relações que, na prática, funcionam como emprego. A escolha do enquadramento deve considerar o cenário completo do profissional e da barbearia.",
            },
        ],
        ctaTexto:
            "Conte como a sua barbearia opera. Um especialista Contabeleza mostra como organizar contratos, comissões e tributos.",
    },
    esmalteria: {
        slug: "esmalteria",
        nome: "Esmalteria",
        segmento: "esmalterias",
        title: "Contabilidade para Esmalteria, Contabeleza",
        description:
            "Contabilidade especializada para esmalterias: formalização, documentos em ordem, Lei do Salão Parceiro para manicures parceiras e tributos organizados.",
        eyebrow: "Para esmalterias",
        h1Lines: ["Sua esmalteria formal,", "organizada e pronta", "para crescer."],
        subtitle:
            "Documentos em dia, manicures parceiras estruturadas e tributos sob controle, com quem entende o setor da beleza por dentro.",
        proposta:
            "Esmalteria vive de volume: muitos atendimentos, ticket enxuto e equipe em crescimento. A Contabeleza organiza a formalização, os documentos fiscais e a relação com as profissionais, para a operação ganhar escala sem perder o controle.",
        dores: [
            "Informalidade que trava financiamentos e parcerias",
            "Dúvida sobre quais documentos fiscais manter organizados",
            "Manicures sem contrato claro de parceria ou de trabalho",
            "Falta de visão sobre margem por serviço",
        ],
        beneficios: [
            "Abertura e regularização do CNPJ no enquadramento correto",
            "Rotina documental simples e organizada para o Fisco",
            "Apoio na estruturação de parcerias com manicures pela Lei nº 13.352/2016",
            "Relatórios que mostram a margem de cada serviço",
        ],
        servicos: [
            "Abertura e regularização de empresa",
            "Gestão tributária especializada",
            "Adequação à Lei do Salão Parceiro",
            "BPO financeiro",
        ],
        imagem: {
            src: IMG_PROFISSIONAL,
            alt: "Profissional de beleza atendendo cliente em estúdio amplo e iluminado",
            width: 1200,
            height: 900,
        },
        depoimentos: [],
        faq: [
            {
                pergunta: "Quais documentos uma esmalteria precisa organizar?",
                resposta:
                    "CNPJ e alvarás, contratos de trabalho ou de parceria das profissionais, notas fiscais emitidas, comprovantes de despesas, registros de caixa e guias de tributos. Com essa base organizada, a escrituração flui e o risco de pendências com o Fisco diminui.",
            },
            {
                pergunta: "Esmalteria pode trabalhar com manicures parceiras?",
                resposta:
                    "Sim. A atividade de manicure e pedicure está prevista na Lei nº 13.352/2016. É preciso formalizar o contrato de parceria, documentar a divisão de cotas e manter práticas de gestão compatíveis, a autonomia da profissional precisa existir na prática, não só no papel.",
            },
            {
                pergunta: "Adotar a parceria zera o risco trabalhista?",
                resposta:
                    "Não existe risco zero. O contrato de parceria bem estruturado e praticado no dia a dia reduz riscos, mas relações com subordinação, jornada fixa e habitualidade podem ser reconhecidas como emprego. A orientação contábil e jurídica contínua é o que mantém o modelo saudável.",
            },
            {
                pergunta: "Manicure pode atender como MEI?",
                resposta:
                    "A atividade de manicure pode ser exercida como MEI, e muitas profissionais se formalizam assim. Para a esmalteria, o que importa é a natureza real da relação: se houver subordinação e jornada, o MEI não afasta o risco de vínculo. O desenho correto depende da operação.",
            },
        ],
        ctaTexto:
            "Conte o momento da sua esmalteria. Um especialista Contabeleza indica o caminho de formalização e organização.",
    },
    spa: {
        slug: "spa",
        nome: "Spa",
        segmento: "spas",
        title: "Contabilidade para Spa, Contabeleza",
        description:
            "Contabilidade especializada para spas: tributação sob medida para serviços de estética e bem-estar, equipes estruturadas e gestão integrada.",
        eyebrow: "Para spas",
        h1Lines: ["Gestão tranquila", "para quem entrega", "tranquilidade."],
        subtitle:
            "Tributação correta para serviços de estética e bem-estar, equipe estruturada e financeiro sereno, como a experiência que o seu spa entrega.",
        proposta:
            "O spa combina serviços de estética, bem-estar e, muitas vezes, profissionais com formações diferentes. A Contabeleza organiza enquadramento fiscal, contratos e financeiro para cada frente da operação, com a mesma serenidade que o seu cliente espera encontrar.",
        dores: [
            "Insegurança sobre o enquadramento fiscal dos serviços de estética",
            "Equipe mista: CLTs, parceiros e locações sem regra clara",
            "Pacotes e sessões vendidos sem controle de margem",
            "Financeiro e contabilidade rodando em sistemas separados",
        ],
        beneficios: [
            "Planejamento tributário específico para serviços de estética e bem-estar",
            "Orientação sobre os modelos de contratação adequados para cada profissional",
            "BPO financeiro com visão de lucratividade por serviço",
            "Rotina integrada com a plataforma ilove.me",
        ],
        servicos: [
            "Gestão tributária especializada",
            "Adequação à Lei do Salão Parceiro",
            "BPO financeiro",
            "Rotinas de equipe e contratações",
        ],
        imagem: {
            src: IMG_CLINICA,
            alt: "Clínica de estética e spa com equipamentos modernos e arquitetura limpa",
            width: 1200,
            height: 900,
        },
        depoimentos: [
            {
                quote: "Todo o negócio de estética deveria ter um parceiro assim.",
                name: "Eva",
                business: "Clínica de Estética, Jundiaí",
            },
        ],
        faq: [
            {
                pergunta: "Como funciona a contabilidade de um spa?",
                resposta:
                    "A contabilidade define o enquadramento fiscal dos serviços oferecidos, organiza notas fiscais, estrutura os contratos da equipe e acompanha o financeiro. Como spas costumam misturar estética, terapias e venda de produtos, cada frente de receita precisa estar corretamente registrada.",
            },
            {
                pergunta: "Spa pode aderir à Lei do Salão Parceiro?",
                resposta:
                    "Serviços de estética estão entre as atividades previstas na Lei nº 13.352/2016, então muitos spas podem operar com profissionais parceiros. O enquadramento depende dos serviços efetivamente prestados e da estrutura da operação, uma análise individual é sempre necessária.",
            },
            {
                pergunta: "Quais documentos um spa precisa manter em ordem?",
                resposta:
                    "Alvará e licenças, contratos da equipe (CLT ou parceria), notas fiscais de serviços e de produtos, comprovantes de despesas e guias de tributos. Spas que trabalham com procedimentos estéticos devem atentar também às exigências sanitárias da sua cidade.",
            },
            {
                pergunta: "Vender pacotes muda a tributação do spa?",
                resposta:
                    "Pacotes são receita de serviço como qualquer outra, mas exigem controle: a receita precisa ser reconhecida corretamente e o prazo de uso dos pacotes deve estar claro para o cliente. Uma escrituração organizada evita divergências entre caixa e faturamento.",
            },
        ],
        ctaTexto:
            "Conte como o seu spa opera. Um especialista Contabeleza analisa o enquadramento e a organização da sua gestão.",
    },
};
